import type { ReactNode } from "react";
import { cx } from "./cx";

/** Cada tom tem UM significado no escritório; não escolher pela cor. */
export type TomEtiqueta =
  | "pronto"    // pode protocolar, aceita, concluída no prazo, ação do assistente
  | "conferir"  // conferência, audiência, depende de uma pessoa
  | "cliente"   // aguardando documento ou resposta do cliente
  | "alerta"    // prazo em risco, recusada, atrasada
  | "neutro";   // a fazer, protocolado, arquivado

const TOM: Record<TomEtiqueta, string> = {
  pronto: "bg-pronto-fundo text-pronto",
  conferir: "bg-conferir-fundo text-conferir",
  cliente: "bg-cliente-fundo text-cliente",
  alerta: "bg-alerta-fundo text-alerta",
  neutro: "bg-superficie-2 text-texto-3",
};

export function Etiqueta({ tom = "neutro", children, className }: { tom?: TomEtiqueta; children: ReactNode; className?: string }) {
  return (
    <span className={cx("inline-flex h-5 w-fit max-w-full items-center rounded-controle px-2 text-meta font-medium whitespace-nowrap", TOM[tom], className)}>
      <span className="truncate">{children}</span>
    </span>
  );
}
